import { render, staticRenderFns } from "./Rulesets.vue?vue&type=template&id=02e8a354&scoped=true"
import script from "./Rulesets.vue?vue&type=script&lang=js"
export * from "./Rulesets.vue?vue&type=script&lang=js"
import style0 from "./Rulesets.vue?vue&type=style&index=0&id=02e8a354&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02e8a354",
  null
  
)

export default component.exports